import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const faqs = [
  {
    q: 'Cât durează realizarea mobilierului la comandă?',
    a: 'Timpul de execuție variază în funcție de complexitatea proiectului. În general, un proiect standard durează între 3-6 săptămâni de la confirmarea designului. Pentru proiecte mai complexe, vă vom oferi un calendar detaliat la semnarea contractului.',
  },
  {
    q: 'Ce materiale folosiți pentru mobilier?',
    a: 'Lucrăm cu o gamă largă de materiale premium: lemn masiv (stejar, fag, nuc, frasin), PAL și MDF de înaltă calitate, lacuri și vopsele ecologice, feronerie germană și italiană. Toate materialele sunt certificate și provin de la furnizori de încredere.',
  },
  {
    q: 'Oferiți servicii de proiectare și design?',
    a: 'Da! Serviciul nostru include consultanță gratuită la domiciliu, proiectare și design al mobilierului, alegerea materialelor și culorilor, și revizuiri nelimitate ale designului până când sunteți complet mulțumiți.',
  },
  {
    q: 'Care este zona în care oferiți servicii?',
    a: 'Suntem localizați în Dumbrăveni, județul Suceava, și acționăm în toată România, cu precădere în zona Moldovei. Pentru proiecte în afara zonei, costurile de transport și montaj pot varia.',
  },
  {
    q: 'Cum funcționează procesul de comandă?',
    a: 'Procesul este simplu: 1) Ne contactați pentru o consultanță gratuită. 2) Venim la măsurători și discutăm preferințele. 3) Realizăm proiectul de design. 4) După aprobare, începem producția. 5) Livrăm și montăm mobilierul.',
  },
  {
    q: 'Oferiți garanție pentru mobilier?',
    a: 'Da, oferim garanție de 2-5 ani pentru toate produsele noastre, în funcție de tipul mobilierului. Garanția acoperă defectele de fabricație și materialele. De asemenea, oferim servicii post-vânzare pentru orice ajustare necesară.',
  },
];

export default function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section data-testid="faq-section" className="py-20 lg:py-32 bg-[#F9F6F0] dark:bg-[#1A1918]">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#A67B5B] mb-4">
            Întrebări frecvente
          </p>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl tracking-tight font-medium text-[#2C2A29] dark:text-[#F0EDE8]">
            Totul despre procesul nostru
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-[#E3DACB] dark:border-[#3D3A37] rounded-lg px-6 bg-white dark:bg-[#242322]"
            >
              <AccordionTrigger className="text-left font-['Outfit'] text-base font-medium text-[#2C2A29] dark:text-[#F0EDE8] hover:no-underline py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-[#6B6561] dark:text-[#9B9590] pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
